import { useEffect, useRef, useState } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { debounce } from 'lodash';
import mqtt from 'mqtt';

import { EnumAppType, EnumClientType } from '../constants/enum';
import { exchangeRawAccessToken } from '../authentication/actions';

const mapState = state => ({
  auth: state.auth,
});

const useMqtt = (appType = EnumAppType.NOW_MERCHANT_APP) => {
  const dispatch = useDispatch();
  const {
    auth: { token, user },
  } = useMappedState(mapState);
  const createMqttUsername = () => {
    const { uid, foodyUid, username } = user;
    return `uid=${uid}&foody_uid=${foodyUid}&username=${username}&app_type=${appType}`;
  };

  const createMqttPassword = useRef();
  createMqttPassword.current = () =>
    `access_token=${token}&client_type=${
      EnumClientType.CLIENT_WEB
    }&client_version=${'1.0'}&client_id=&client_language=vn`;

  const [mqttClient] = useState(() => {
    const clientId = `mqttjs_${Math.random()
      .toString(16)
      .substring(2)}`;

    const options = {
      protocol: CONFIG.MQTT_WS,
      host: CONFIG.MQTT_HOST,
      port: CONFIG.MQTT_PORT,
      qos: 2,
      path: '/mqtt',
      clientId,
      reconnectPeriod: 5000,
      username: createMqttUsername(),
      get password() {
        return createMqttPassword.current();
      },
    };

    return mqtt.connect(options);
  });

  useEffect(() => {
    mqttClient.on(
      'error',
      debounce((error) => {
        console.error(error.toString());
        // This is a hack to know that access token is expired
        if (error.toString().includes('Bad username or password')) {
          dispatch(exchangeRawAccessToken()).then(() => {
            mqttClient.reconnect();
          });
        }
      }, 500),
    );

    return () => {
      mqttClient.end();
    };
  }, [dispatch, mqttClient]);

  return { mqttClient };
};

export default useMqtt;



// WEBPACK FOOTER //
// ./foody/src/hooks/mqttHooks.js